import { ServiceAgreementApis } from './../apis/serviceAgreements';
import { RemoteResourceV3, updateRemoteResourceV3 } from './../../commonv3/api/RemoteResourceV3';
import { observable, computed, action, makeObservable } from 'mobx';
import { ServiceAgreement } from '../../commonv3/types/serviceAgreements';

export enum ServiceAgreementKey {
  STANDARD = 'standard',
}

export class ServiceAgreementState {
  serviceAgreementResource: RemoteResourceV3<ServiceAgreement> = RemoteResourceV3.loading();
  cardsChecked: boolean[];
  lastChecked: boolean;

  constructor() {
    makeObservable(this, {
      serviceAgreementResource: observable,
      cardsChecked: observable,
      lastChecked: observable,
      init: action.bound,
      serviceAgreement: computed,
      isAllAgreed: computed,
      setCardChecked: action.bound,
      setLastChecked: action.bound,
    });
  }

  async init(key: string = ServiceAgreementKey.STANDARD) {
    await updateRemoteResourceV3(
      this.serviceAgreementResource,
      (v) => (this.serviceAgreementResource = v),
      () => ServiceAgreementApis.show(key)
    );
    if (this.serviceAgreement) {
      this.cardsChecked = Array(this.serviceAgreement.check_points.length).fill(false);
    }
  }

  get serviceAgreement() {
    return this.serviceAgreementResource.get(); //ここは仮
  }

  get isAllAgreed() {
    return this.lastChecked && this.cardsChecked.every((b) => b);
  }

  setCardChecked(i: number, checked: boolean) {
    this.cardsChecked[i] = checked;
  }

  setLastChecked(checked: boolean) {
    this.lastChecked = checked;
  }
}
